document.addEventListener('DOMContentLoaded', function () {
  const selectElements = document.querySelectorAll('select');
  selectElements.forEach(function (selectElement) {
    const fieldElement = selectElement.parentElement;
    checkEmptySelected(selectElement, fieldElement);
    selectElement.addEventListener('change', function () {
      checkEmptySelected(selectElement, fieldElement);
      setTimeout(() => {
        recheckSelects(selectElements);
      }, 1000);
    });
  });

  function checkEmptySelected(selectElement, fieldElement) {
    if (selectElement.value === '') {
      fieldElement.classList.add('empty-selected');
    } else {
      fieldElement.classList.remove('empty-selected');
    }
  }

  function recheckSelects(selectElements) {
    selectElements.forEach(function (selectElement) {
      const fieldElement = selectElement.parentElement;
      checkEmptySelected(selectElement, fieldElement);
    });
  }




  const telInputs = document.querySelectorAll('input[type="tel"]');
  telInputs.forEach(function (input) {
    input.addEventListener('input', function (event) {
      const inputValue = event.target.value.trim();
      const numericValue = inputValue.replace(/\D/g, '');
      const maxLength = 9;
      event.target.value = numericValue.slice(0, maxLength);
    });
  });
  typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  var btn = document.getElementById('add-new-address');
  var modal = document.querySelector('.modal');

  btn.onclick = function () {
    modal.classList.add('show');
  };
  const cancelButtons = document.querySelectorAll('.cancel-edit');
  cancelButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const editAddress = this.closest('.editAddress');
      editAddress.style.display = 'none';
    });
  });

  const deleteButtons = document.querySelectorAll('.btn-delete');
  deleteButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const confirmMessage = button.getAttribute('data-confirm-message');
      const addressUrl = button.getAttribute('data-target');

      if (confirm(confirmMessage)) {
        Shopify.postLink(addressUrl, {
          parameters: { _method: 'delete' },
        });
      }
    });
  });

  const editButtons = document.querySelectorAll('[id^="EditFormButton_"]');
  editButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const addressId = button.getAttribute('data-address-id');
      const editAddress = document.getElementById(`EditAddress_${addressId}`);
      if (editAddress) {
        editAddress.style.display = 'flex';
        const selectElements = document.querySelectorAll('select');
        selectElements.forEach(function (selectElement) {
          const fieldElement = selectElement.parentElement;
          checkEmptySelected(selectElement, fieldElement);
          selectElement.addEventListener('change', function () {
            checkEmptySelected(selectElement, fieldElement);
            setTimeout(() => {
              recheckSelects(selectElements);
            }, 1000);
          });
        });
      }
    });
  });

  let regionesComunas;
  let urlFetch = 'https://calendar-app.kitchencenter.cl/api/calendar/regions';
  fetch(urlFetch)
    .then(response => {
      if (!response.ok) {
        throw new Error('No se pudo obtener la lista de regiones y comunas');
      }
      return response.json();
    })
    .then(data => {
      delete data.Portugal;
      delete data.Regi;

      let regionTransform = {};

      for (const region in data) {
        const comunas = data[region].map(distrito => distrito.district);

        const short_code = data[region][0].short_code;

        regionTransform[region] = {
          region: region,
          short_code: short_code,
          comunas: comunas
        };
      }

      const regionsArray = Object.values(regionTransform);

      const resultsEnd = {
        regiones: regionsArray
      };
      regionesComunas = resultsEnd;
      loadRegionsCreate();
      loadRegionsEdit();
    })
    .catch(error => {
      console.error('Error:', error);
    });

  function loadRegionsCreate() {
    const select = document.getElementById('AddressCityNew');
    regionesComunas.regiones.forEach(region => {
      const option = document.createElement('option');
      option.value = region.short_code;
      option.textContent = region.region;
      select.appendChild(option);
    });
  }

  function loadComunasCreate(region) {
    const comunaSelect = document.getElementById('AddressComunaNew');
    comunaSelect.innerHTML = '<option value=""></option>';
    const regionData = regionesComunas.regiones.find(r => r.region === region);
    if (regionData) {
      regionData.comunas.forEach(comuna => {
        const option = document.createElement('option');
        option.value = comuna;
        option.textContent = comuna;
        comunaSelect.appendChild(option);
      });
    }
  }

  document.getElementById('AddressCityNew').addEventListener('change', function () {
    const selectedRegion = this.value;
    if (selectedRegion) {
      const regionData = regionesComunas.regiones.find(r => r.short_code === selectedRegion);
      if (regionData) {
        loadComunasCreate(regionData.region);
      }
    } else {
      document.getElementById('AddressComunaNew').innerHTML = '<option value=""></option>';
    }
  });

  function loadRegionsEdit() {
    const selects = document.querySelectorAll('[id^="AddressCity_"]');
    selects.forEach(select => {
      const defaultRegion = select.dataset.default;
      if (defaultRegion) {
        regionesComunas.regiones.forEach(region => {
          const option = document.createElement('option');
          option.value = region.short_code;
          option.textContent = region.region;
          if (region.region === defaultRegion) {
            option.selected = true;
          }
          // select.appendChild(option);
        });

        const selectId = select.id.replace('AddressCity_', 'AddressZip_');
        const defaultComuna = select.dataset.defaultcx;
        loadComunasEdit(defaultRegion, selectId, defaultComuna);
      }
    });
  }

  function loadComunasEdit(region, selectId, defaultComuna) {
    const comunaSelect = document.getElementById(selectId);
    const defaultData = comunaSelect.getAttribute('data-default');
    // comunaSelect.innerHTML = '<option value=""></option>';
    const regionData = regionesComunas.regiones.find(r => r.short_code == region);
    if (regionData) {
      regionData.comunas.forEach(comuna => {
        const option = document.createElement('option');
        option.value = comuna;
        option.textContent = comuna;
        if (comuna === defaultData) {
          option.setAttribute('selected', "selected");
        }
        comunaSelect.appendChild(option);
      });
    }
  }

  const selects = document.querySelectorAll('[id^="AddressCity_"]');
  selects.forEach(select => {
    select.addEventListener('change', function () {
      const selectedOption = this.selectedOptions[0];
      const selectedRegion = selectedOption.textContent;
      const selectId = this.id.replace('AddressCity_', 'AddressZip_');
      if (selectedRegion) {
        loadComunasEdit(selectedRegion, selectId);
      } else {
        document.getElementById(selectId).innerHTML = '<option value=""></option>';
      }
    });
  });

  const rutInputs = document.querySelectorAll('.rutFormat');

  rutInputs.forEach(input => {
    input.addEventListener('input', function (event) {
      const idError = this.dataset.idError;
      const rutError = document.getElementById(idError);
      const lastChar = this.value.charAt(this.value.length - 1);
      const validCharsRegex = /^[0-9kK.-]$/;

      if (this.value.length > 0 && !validCharsRegex.test(lastChar)) {
        this.value = this.value.slice(0, -1);
        return;
      }
      let submitNewButton = document.querySelector('#submitNew');
      formatInput(this, false);
      if (this.value.length > 8) {
        const isValid = isValidRut(this.value, { minimumLength: true });
        if (isValid) {
          hideError(this.parentElement, rutError);
          submitNewButton.disabled = false;
        } else {
          showError(this.parentElement, rutError, 'Ingresa un RUT válido');
          submitNewButton.disabled = true;
        }
      } else {
        showError(this.parentElement, rutError, 'Ingresa un RUT válido');
        submitNewButton.disabled = true;
      }
    });

    input.addEventListener('blur', function (event) {
      const idError = this.dataset.idError;
      const rutError = document.getElementById(idError);
      const lastChar = this.value.charAt(this.value.length - 1);
      const validCharsRegex = /^[0-9kK.-]$/;

      if (this.value.length > 0 && !validCharsRegex.test(lastChar)) {
        this.value = this.value.slice(0, -1);
        return;
      }
      let submitButton = document.querySelector('#submitUpdate');
      if (this.value.length != 0) {
        if (this.value.length > 8) {
          const isValid = isValidRut(this.value, { minimumLength: true });
          if (isValid) {
            hideError(this.parentElement, rutError);
            submitButton.disabled = false;
          } else {
            showError(this.parentElement, rutError, 'Ingresa un RUT válido');
            submitButton.disabled = true;
          }
        } else {
          showError(this.parentElement, rutError, 'Ingresa un RUT válido');
          submitButton.disabled = true;
        }
      } else {
        showError(this.parentElement, rutError, 'Ingresa tu RUT');
        submitButton.disabled = true;
      }
    });
  });


  function showError(field, errorField, errorMessage) {
    errorField.textContent = errorMessage;
    field.style.borderColor = "#CA1722";
  }

  function hideError(field, errorField) {
    errorField.textContent = '';
    field.style.borderColor = '#9C9C9C';
  }



});